module.exports = __webpack_public_path__ + "static/media/BlogCaldasNovas2.9f7b0f86.jpg";